import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { notification, Input, Row, Col, Pagination, Empty, Spin, Segmented, Button, Typography, Modal, Upload, Avatar, Radio, Alert, Tag } from 'antd';
import { FixedSizeList as VirtualList } from 'react-window';
import lib, { myRequestObj, myRequest } from '../../assets/utils/lib';
import { isPaymentAdvicePending, PAID_ADVICE_PENDING_LABEL } from '../../components/Claims/Payment/paymentAdvice';
import { uri, uri_img } from '../../assets/utils/http-request';
import  config from '../../assets/utils/config';
import { NullSafe } from '../../assets/utils/Helpers';
import Loader from '../compoinents/loader';
import { FileTextOutlined, BankOutlined, CheckOutlined, DollarOutlined, ReloadOutlined, EnvironmentOutlined, MailOutlined, PhoneOutlined, TeamOutlined, PlusOutlined, CalendarOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { RiHospitalFill } from 'react-icons/ri';
import Draggable from 'react-draggable';
import CurrencyFormat from 'react-currency-format';
import debounce from 'lodash/debounce';
import StandardFilter from '../compoinents/StandardFilter';
import { useStandardFilter } from '../compoinents/useStandardFilter';
import { CLAIMS_FILTERS } from '../compoinents/FilterConfigs';
import { usePermissions } from '../../assets/utils/usePermissions';

// Import the modern SCSS styles
import '../../styles/main.scss';

const ClaimsListHookPayment = (props) => {
  const user = JSON.parse(localStorage.getItem(config.key.user));
  const [, setClaimsList] = useState([]);
  const [filterdClaimList, setFilterdClaimsList] = useState([]);
  const [, setSortedClaims] = useState([]);
  const [sortedPaidClaims, setSortedPaidClaims] = useState([]);
  const [sortedPendingClaims, setSortedPendingClaims] = useState([]);
  const activeSegment = useRef(2);
  const [loading, setLoading] = useState(false);
  // const [facilities, setFacilities] = useState([]);

  // StandardFilter integration
  const {
    filters,
    loading: filterLoading,
    activeFiltersCount,
    handleFilterChange,
    handleApplyFilters,
    handleClearFilters,
    getFormattedFilters
  } = useStandardFilter({
    initialFilters: {
      search: '',
      fromDate: null,
      toDate: null
      // month: null,
      // year: null,
      // facilityId: null,
      // minCost: null,
      // maxCost: null,
      // insuranceNo: ''
    },
    autoApply: true,
    debounceDelay: 500,
    onApplyFilters: async (filterValues) => {
      const formattedFilters = getFormattedFilters(filterValues);
      const searchTerm = filterValues.search || '';
      
      // Fetch claims with filters applied
      const res = await fetchClaimsList(user.id, activeSegment.current, searchTerm, formattedFilters);
      
      // Update the claims list based on current section or extended view
      setClaimsList(res?.data);
      setSortedClaims(sortClaims(res).sorted);
      
      if (props.extended) {
        setFilterdClaimsList([...sortClaims(res).all_Claims.paid, ...sortClaims(res).all_Claims.pending]);
      } else {
        switch (props.section) {
          case 'paid':
            setFilterdClaimsList([...sortClaims(res).all_Claims.paid]);
            break;
          case 'pending':
            setFilterdClaimsList([...sortClaims(res).all_Claims.pending]);
            break;
          default: break;
        }
      }
      setSortedPaidClaims(sortClaims(res).all_Claims.paid);
      setSortedPendingClaims(sortClaims(res).all_Claims.pending);
    },
    onClearFilters: async () => {
      const res = await fetchClaimsList(user.id, activeSegment.current, '', {});
      
      // Update the claims list based on current section or extended view
      setClaimsList(res?.data);
      setSortedClaims(sortClaims(res).sorted);
      
      if (props.extended) {
        setFilterdClaimsList([...sortClaims(res).all_Claims.paid, ...sortClaims(res).all_Claims.pending]);
      } else {
        switch (props.section) {
          case 'paid':
            setFilterdClaimsList([...sortClaims(res).all_Claims.paid]);
            break;
          case 'pending':
            setFilterdClaimsList([...sortClaims(res).all_Claims.pending]);
            break;
          default: break;
        }
      }
      setSortedPaidClaims(sortClaims(res).all_Claims.paid);
      setSortedPendingClaims(sortClaims(res).all_Claims.pending);
    }
  });

  useEffect(() => {
    setLoading(true);
    fetchClaimsList(user.id).then(res => {
      setClaimsList(res?.data);
      setSortedClaims(sortClaims(res).sorted);
      if (props.extended) {
        setFilterdClaimsList([...sortClaims(res).all_Claims.paid, ...sortClaims(res).all_Claims.pending]);
      } else {
        switch (props.section) {
          case 'paid':
            setFilterdClaimsList([...sortClaims(res).all_Claims.paid]);
            break;
          case 'pending':
            setFilterdClaimsList([...sortClaims(res).all_Claims.pending]);
            break;
          default: break;
        }
      }
      setSortedPaidClaims(sortClaims(res).all_Claims.paid)
      setSortedPendingClaims(sortClaims(res).all_Claims.pending)
    }).finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps



  // Upload modal controls
  const [, setVisiblePaid] = useState(false);

  const sortClaims = (claims) => {
    console.log('sortClaims input:', claims);
    
    if (!claims?.data || !claims?.facilities) {
      console.log('Missing data or facilities in claims response');
      return { sorted: [], sortedPending: [], sortedPaid: [], all_Claims: { paid: [], pending: [], queried: [], rejected: [] } };
    }

    const pendingClaimSort = NullSafe(claims.data.filter(cl => Number(cl?.claims_status) === 2));
    const paidClaimSort = NullSafe(claims.data.filter(cl => Number(cl?.claims_status) === 3));

    console.log('Pending claims:', pendingClaimSort);
    console.log('Paid claims:', paidClaimSort);

    let all_Claims = { paid: [], pending: [], queried: [], rejected: [] };

    // Process pending claims
    claims.facilities.forEach(facility => {
      const facilityPendingClaims = pendingClaimSort.filter(c => c.facility_id === facility.id);
      if (facilityPendingClaims.length > 0) {
        const totalCost = facilityPendingClaims.reduce((sum, claim) => sum + Number(claim.encounter_cost || 0), 0);
        const uniquePatients = new Set(facilityPendingClaims.map(c => c.insurance_no)).size;
        
        all_Claims.pending.push({
          ...facility,
          status: 'Pending',
          color: '#121221',
          claims: facilityPendingClaims,
          claims_count: facilityPendingClaims.length,
          total_encounter_cost: totalCost,
          unique_insurance_count: uniquePatients,
          last_claim_date: facilityPendingClaims[0]?.claims_date || null
        });
      }
    });

    // Process paid claims - group by payment batch
    const paidBatches = {};
    paidClaimSort.forEach(claim => {
      const batchKey = claim.payment_batch || 'no_batch';
      if (!paidBatches[batchKey]) {
        paidBatches[batchKey] = [];
      }
      paidBatches[batchKey].push(claim);
    });

    Object.keys(paidBatches).forEach(batchKey => {
      const batchClaims = paidBatches[batchKey];
      const facilitiesInBatch = new Set(batchClaims.map(c => c.facility_id));
      
      facilitiesInBatch.forEach(facilityId => {
        const facility = claims.facilities.find(f => f.id === facilityId);
        if (facility) {
          const facilityClaims = batchClaims.filter(c => c.facility_id === facilityId);
          const totalCost = facilityClaims.reduce((sum, claim) => sum + Number(claim.encounter_cost || 0), 0);
          const uniquePatients = new Set(facilityClaims.map(c => c.insurance_no)).size;
          
          all_Claims.paid.push({
            ...facility,
            status: 'Paid',
            color: '#00aa00',
            payment_batch: batchKey === 'no_batch' ? null : batchKey,
            claims: facilityClaims,
            claims_count: facilityClaims.length,
            total_encounter_cost: totalCost,
            unique_insurance_count: uniquePatients,
            last_claim_date: facilityClaims[0]?.claims_date || null
          });
        }
      });
    });

    console.log('Processed all_Claims:', all_Claims);

    return { 
      sorted: all_Claims.pending, 
      sortedPending: all_Claims.pending, 
      sortedPaid: all_Claims.paid, 
      all_Claims 
    };
  }

  async function fetchClaimsList(id, segment = activeSegment.current, searchTerm = '', filterParams = {}) {
    const payload = { segment, id, search: searchTerm, ...filterParams };
    console.log('API Payload being sent:', payload);
    return myRequestObj("aClaimsListPayment").post(payload)
      .then((body) => {
        console.log('API Response:', body);
        return body?.data;
      })
  }

  const send_claim_paid = () => {
    fetchClaimsList(user.id, activeSegment.current, filterKeyword).then(res => {
      setClaimsList(res);
      setSortedClaims(sortClaims(res).sorted);
      setFilterdClaimsList([...sortClaims(res).all_Claims.paid, ...sortClaims(res).all_Claims.pending]);
      setSortedPaidClaims(sortClaims(res).all_Claims.paid)
      setSortedPendingClaims(sortClaims(res).all_Claims.pending)
    });
    setVisiblePaid(false)
  }

  // Debounced facility search function - commented out since facility filter is disabled
  // const debouncedFacilitySearch = useMemo(
  //   () => debounce(async (searchTerm) => {
  //     if (!searchTerm || searchTerm.length < 2) {
  //       setFacilities([]);
  //       return;
  //     }
      
  //     try {
  //       const response = await myRequestObj('searchFacilityNew').post({ search: searchTerm });
  //       if (response?.data?.data) {
  //         const facilityOptions = response.data.data.map(facility => ({
  //           label: facility.name,
  //           value: facility.id
  //         }));
  //         setFacilities(facilityOptions);
  //       }
  //     } catch (error) {
  //       console.error('Error searching facilities:', error);
  //       setFacilities([]);
  //     }
  //   }, 300),
  //   []
  // );

  // Handle facility search - commented out since facility filter is disabled
  // const handleFacilitySearch = useCallback((searchTerm) => {
  //   debouncedFacilitySearch(searchTerm);
  // }, [debouncedFacilitySearch]);


  const handleSegmentChange = (value) => {
    activeSegment.current = value
    switch (value) {
      case 2:
        update_claims_list();
        setFilterdClaimsList(sortedPendingClaims);
        break
      case 3:
        update_claims_list();
        setFilterdClaimsList(sortedPaidClaims);
        break
    }
    // Don't clear filters when changing segments, just update the display
    // handleClearFilters()
  }

  const update_claims_list = (id, segment, searchTerm = '', filterParams = {}) => {
    setLoading(true);
    fetchClaimsList(id, segment, searchTerm, filterParams).then(res => {
      setClaimsList(res);
      setSortedClaims(sortClaims(res).sorted);
      if (activeSegment.current === 3) {
        setFilterdClaimsList([...sortClaims(res).all_Claims.paid]);
      }
      else if (activeSegment.current === 2) {
        setFilterdClaimsList([...sortClaims(res).all_Claims.pending]);
      }
      setSortedPaidClaims(sortClaims(res).all_Claims.paid)
      setSortedPendingClaims(sortClaims(res).all_Claims.pending)
    }).finally(() => setLoading(false));
  }

  return (
    <div className="claims-payment-container">
      <div className="claims-payment-header">
        {props.extended && (
          <div className="claims-payment-segments">
            <Segmented
              block
              options={[
                {
                  label: (
                    <div className="segment-label pending">
                      <FileTextOutlined />
                      Pending
                    </div>
                  ),
                  value: 2
                },
                {
                  label: (
                    <div className="segment-label paid">
                      <DollarOutlined />
                      Paid
                    </div>
                  ),
                  value: 3
                }
              ]}
              onChange={handleSegmentChange}
              style={{ userSelect: 'none' }}
            />
          </div>
        )}

        {/* Standard Filter Component - Always visible */}
        <StandardFilter
          filters={CLAIMS_FILTERS.payment}
          onFilterChange={handleFilterChange}
          onApplyFilters={handleApplyFilters}
          onClearFilters={handleClearFilters}
          initialValues={filters}
          loading={filterLoading}
          collapsible={true}
          defaultExpanded={false}
          title={
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '50px'
            }}>
              <span style={{ 
                fontWeight: 600, 
                fontSize: '16px',
                color: 'var(--ant-text-color, #1e293b)',
                letterSpacing: '-0.01em',
                alignSelf: 'flex-start'
              }}>
                Advanced Filters
              </span>
              <Button
                onClick={e => {
                  const formattedFilters = getFormattedFilters(filters);
                  update_claims_list(user?.id, activeSegment.current, filters.search, formattedFilters);
                }}
                type="primary"
                icon={<ReloadOutlined />}
                size="small"
                loading={loading}
                style={{
                  borderRadius: '6px',
                  height: '28px',
                  fontSize: '12px',
                  fontWeight: 500,
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  border: 'none',
                  marginLeft: 'auto',
                  alignSelf: 'flex-end'
                }}
              >
                Reload
              </Button>
            </div>
          }
          showActiveCount={true}
          showSearchIcon={true}
          style={{ marginBottom: '16px' }}
        />
      </div>

      <div className="claims-payment-content">
        {loading ? (
          <Loader />
        ) : !filterdClaimList.length ? (
          <div className="claims-payment-empty">
            <Empty
              description={
                <span>
                  There are no claims in this category
                </span>
              }
            />
          </div>
        ) : (
          <div className="payment-batches-grid">
            {filterdClaimList.map((claim, index) => (
              <PaymentBatchListing
                key={index}
                claim={claim}
                segment={activeSegment.current}
                index={index}
                paymentHandle={() => send_claim_paid()}
                extended={props.extended}
                section={props.section}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const PaymentBatchListing = ({ claim, index, segment, paymentHandle, extended }) => {
  const { hasAnyPermissionWithLegacy } = usePermissions();
  // Mirrors the backend gate on ?saveBatchDoc (ClaimsMoneyWriteGate
  // ACTION_PAYMENT_RECORD): recording a payment is the Finance/CFO stage,
  // not the claims-adjudication one, so legacy 3/4 don't qualify even
  // though the route module lets them open this screen.
  const canRecordPayment = hasAnyPermissionWithLegacy(['claims.payment', 'payments.create'], [1, 5]);
  const [claimsIdsOfTheBatch, setClaimsIdsOfTheBatch] = useState([]);
  const [dataView, setDataView] = useState(false);
  const navigate = useNavigate();

  // Upload modal controls
  const [visiblePaid, setVisiblePaid] = useState(false);
  const [payMethod, setPayMethod] = useState('upload');
  const [payingWithout, setPayingWithout] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const draggleRef = useRef(null);

  const handlePayButton = () => {
    setPayMethod('upload');
    setVisiblePaid(true)
    setClaimsIdsOfTheBatch(d => (claim.claims.map((c, i) => c.claims_id)))
  }

  const send_claim_paid = () => {
    paymentHandle();
    setVisiblePaid(false)
  }

  // Mark as Paid now; the payment advice is uploaded later from the payment desk.
  const payWithoutAdvice = () => {
    setPayingWithout(true);
    lib.payClaimsV2({ claimsIds: claimsIdsOfTheBatch, withoutAdvice: true })
      .then((response) => {
        const body = response?.data ?? response;
        if (response?.error ?? body?.error) {
          notification.error({ message: 'Payment Failed', description: response?.message ?? body?.message, placement: 'topLeft' });
          return;
        }
        notification.success({
          message: 'Marked as Paid',
          description: `Claims marked ${PAID_ADVICE_PENDING_LABEL}.`,
          placement: 'topLeft',
        });
        send_claim_paid();
      })
      .finally(() => setPayingWithout(false));
  }

  const handleCancel = () => {
    setVisiblePaid(false);
  };

  const handleView = () => {
    setDataView(!dataView);
    setClaimsIdsOfTheBatch(d => (claim.claims.map((c, i) => c.claims_id)))
  }

  const handleClick = (entry, segment) => {
    navigate(`/claims/filings/${btoa(entry)}/${btoa(segment)}`, { state: { segment, entry } })
  }

  const onStart = (_event, uiData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();

    if (!targetRect) {
      return;
    }

    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  });

  if (!claim['claims'].length) return null;

  const totalCost = claim.claims.reduce((prev, curr) => prev + Number(curr.encounter_cost), 0);

  // HM review indicators aggregated at facility/payment-batch level
  const reviewFlags = claim.claims.map(c => Number(c.review_required ?? 0));
  const hasHMReview = reviewFlags.includes(1);           // Returned by HM
  const isHMResolutionPending = !hasHMReview && reviewFlags.includes(2); // Awaiting HM review

  // Collect all HM comments from inner claims
  const allCommentSegments = [];
  claim.claims.forEach(c => {
    const raw = typeof c.claims_comment === 'string' ? c.claims_comment : '';
    if (!raw) return;
    raw.split('|break|')
      .map(s => s.trim())
      .filter(s => s)
      .forEach(s => allCommentSegments.push(s));
  });

  const medicalPrefix = 'medical comment';
  const medicalSegments = allCommentSegments.filter(s =>
    s.toLowerCase().startsWith(medicalPrefix)
  );

  // Latest relevant HM comment for this batch
  const hmSnippetRaw =
    (medicalSegments.length ? medicalSegments[medicalSegments.length - 1] : '') ||
    (allCommentSegments.length ? allCommentSegments[allCommentSegments.length - 1] : '');
  const hmSnippet = hmSnippetRaw ? hmSnippetRaw.replace(/>>>/g, '→') : '';

  console.log('hmSnippetRaw', hmSnippetRaw);
  console.log('medicalSegments', medicalSegments);
  console.log('allCommentSegments', allCommentSegments);
  console.log('hmSnippet', hmSnippet);
  return (
    <div className="payment-batch-card">
      <div className={`batch-status-ribbon ${claim.status.toLowerCase()}`}>
        {claim.status}
      </div>
      
      <div className="batch-card-content">
        <div className="batch-header">
          <div className="facility-avatar">
            <Avatar size={64} icon={<RiHospitalFill />} />
          </div>
          <div className="facility-info">
            <h3 className="facility-name">{claim.name}</h3>
            <div className="facility-location">
              <EnvironmentOutlined />
              {claim.city} / {claim.state}
            </div>
            {extended && (
              <div className="facility-phone">
                <PhoneOutlined />
                <a href={`tel:${claim.phone}`}>{claim.phone}</a>
              </div>
            )}
            {(hasHMReview || isHMResolutionPending) && hmSnippet && (
              <div className="facility-hm-status">
                <span
                  style={{
                    display: 'inline-block',
                    marginTop: 4,
                    padding: '2px 8px',
                    borderRadius: 12,
                    fontSize: 11,
                    fontWeight: 600,
                    color: hasHMReview ? '#b91c1c' : '#92400e',
                    backgroundColor: hasHMReview ? '#fee2e2' : '#fffbeb',
                    border: `1px solid ${hasHMReview ? '#fecaca' : '#fed7aa'}`
                  }}
                  title={hmSnippet}
                >
                  {hasHMReview ? 'Returned by HM' : 'Awaiting HM review'}
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="batch-stats">
          <div className="stat-item">
            <div className="stat-icon">
              <FileTextOutlined />
            </div>
            <div className="stat-content">
              <div className="stat-value">{claim.claims.length}</div>
              <div className="stat-label">Claims</div>
            </div>
          </div>

          <div className="stat-item">
            <div className="stat-icon">
              <DollarOutlined />
            </div>
            <div className="stat-content">
              <div className="stat-value">
                <CurrencyFormat
                  value={totalCost}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={'₦'}
                />
              </div>
              <div className="stat-label">Approved Cost</div>
            </div>
          </div>

          {/* Date Submitted */}
          <div className="stat-item">
            <div className="stat-icon">
              <CalendarOutlined />
            </div>
            <div className="stat-content">
              <div className="stat-value">
                {claim.last_claim_date ? new Date(claim.last_claim_date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric'
                }) : 'N/A'}
              </div>
              <div className="stat-label">Date Submitted</div>
            </div>
          </div>

          {/* Date Paid - Only show for paid claims */}
          {claim.status === 'Paid' && claim.claims[0]?.date_paid && (
            <div className="stat-item">
              <div className="stat-icon">
                <CheckOutlined />
              </div>
              <div className="stat-content">
                <div className="stat-value">
                  {new Date(claim.claims[0].date_paid).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </div>
                <div className="stat-label">Date Paid</div>
              </div>
            </div>
          )}

          {/* Pending Status - Only show for pending claims */}
          {claim.status === 'Pending' && (
            <div className="stat-item">
              <div className="stat-icon">
                <ClockCircleOutlined />
              </div>
              <div className="stat-content">
                <div className="stat-value">
                  {claim.claims[0]?.claims_date ? 
                    Math.ceil((new Date() - new Date(claim.claims[0].claims_date)) / (1000 * 60 * 60 * 24)) : 'N/A'
                  }
                </div>
                <div className="stat-label">Days Pending</div>
              </div>
            </div>
          )}

          {/* HM Review Snippet */}
          {(hasHMReview || isHMResolutionPending) && hmSnippet && (
            <div className="stat-item" style={{ flexBasis: '100%', marginTop: 8 }}>
              <div className="stat-icon">
                <FileTextOutlined style={{ color: hasHMReview ? '#f5222d' : '#faad14' }} />
              </div>
              <div className="stat-content">
                <div
                  className="stat-label"
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    color: hasHMReview ? '#b91c1c' : '#92400e'
                  }}
                >
                  {hasHMReview ? 'Latest HM comment' : 'Latest HM note'}
                </div>
                <div
                  className="stat-value"
                  style={{
                    fontSize: 12,
                    color: '#374151',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 220
                  }}
                  title={hmSnippet}
                >
                  {hmSnippet}
                </div>
              </div>
            </div>
          )}
        </div>

        {extended && (
          <div className="batch-actions">
            <Button
              type="primary"
              onClick={() => handleClick(claim?.id, segment)}
              className="view-button"
            >
              View Details
            </Button>
            
            {canRecordPayment && !claim.claims[0].payment_batch && (
              <Button
                type="primary"
                danger
                onClick={() => handlePayButton(index)}
                disabled={claim?.status === 'Paid'}
                className="pay-button"
              >
                Mark as Paid
              </Button>
            )}
            
                         {claim.claims.length && isPaymentAdvicePending(claim.claims[0]) ? (
               <Tag color="orange">{PAID_ADVICE_PENDING_LABEL}</Tag>
             ) : null}
                         {claim.claims.length && parseInt(claim.claims[0].claims_status) === 3 && claim.claims[0].payment_batch && !isPaymentAdvicePending(claim.claims[0]) && (
               <Button
                 type="link"
                 href={`${uri}documents/claims/payments/claims/${claim.claims[0].payment_batch}.pdf`}
                 target={'_blank'}
                 className="document-button"
               >
                 Payment Document
               </Button>
             )}
          </div>
        )}
      </div>

      <Modal
        title={
          <div
            style={{
              width: '100%',
              cursor: 'move',
            }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false);
              }
            }}
            onMouseOut={() => {
              setDisabled(true);
            }}
            onFocus={() => { }}
            onBlur={() => { }}
          >
            Mark as Paid
          </div>
        }
        width='420px'
        footer={payMethod === 'without' ? null : undefined}
        visible={visiblePaid}
        onOk={send_claim_paid}
        onCancel={handleCancel}
        destroyOnClose
        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            bounds={bounds}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
        okText={'Done'}
      >
        <Radio.Group
          value={payMethod}
          onChange={(e) => setPayMethod(e.target.value)}
          disabled={payingWithout}
          style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}
        >
          <Radio value="upload">Upload Payment Advice</Radio>
          <Radio value="without">Mark as Paid Without Payment Advice</Radio>
        </Radio.Group>
        {payMethod === 'upload' ? (
          <div className='form-group' style={{ width: 'fit-content', margin: '5px auto' }}>
            <Uploader claimItems={claimsIdsOfTheBatch} done={() => send_claim_paid()} />
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <Alert
              type="info"
              showIcon
              message={`${claimsIdsOfTheBatch.length} claim(s) will be marked Paid.`}
              description={`They will show "${PAID_ADVICE_PENDING_LABEL}" until the payment advice is uploaded from the payment desk.`}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <Button onClick={handleCancel} disabled={payingWithout}>Cancel</Button>
              <Button type="primary" loading={payingWithout} onClick={payWithoutAdvice}>Mark as Paid</Button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

const Uploader = ({ claimItems, done }) => {
  const [loading, setLoading] = useState(false);
  const [uploaded, setUploaded] = useState(false);

  const beforeUpload = (file) => {
    setLoading(true);

    if (file.type !== 'application/pdf') {
      notification.error({ message: 'You can only upload a pdf file!', placement: 'topLeft' });
      setLoading(false);
      return;
    }

    const postData = new FormData();
    postData.append('items', JSON.stringify(claimItems));
    postData.append('file', file);
    myRequest('post', "saveBatchDoc", postData)
      .then(body => body?.data).then(body => {
        if (body.error) {
          setLoading(false);
          setUploaded(false);
        } else {
          notification.success({
            message: body.message,
            placement: 'topLeft'
          })
          done()
          setLoading(false);
          setUploaded(true);
        }
      })

    return false;
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : uploaded ? <CheckOutlined color="green" /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>
        Upload
      </div>
    </div>
  );

  return (
    <Upload
      name="avatar"
      listType="picture-card"
      className="avatar-uploader"
      showUploadList={false}
      beforeUpload={beforeUpload}
      disabled={loading || uploaded}
    >
      {uploadButton}
    </Upload>
  );
};

export default ClaimsListHookPayment;
